import { render, staticRenderFns } from "./EntityConcerned.vue?vue&type=template&id=5d6a8eda&"
import script from "./EntityConcerned.vue?vue&type=script&lang=js&"
export * from "./EntityConcerned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports